import { GridFilterItem, GridFilterModel } from "@mui/x-data-grid-pro";
import { Dispatch, SetStateAction, useCallback } from "react";

const useFilters = (
  filterModel: GridFilterModel,
  setFilterModel: Dispatch<SetStateAction<GridFilterModel>>,
) => {
  const isSameFilter = useCallback((filter: GridFilterItem, newFilter: GridFilterItem) => {
    return (
      filter.field === newFilter.field &&
      JSON.stringify(filter.value) === JSON.stringify(newFilter.value) &&
      filter.operator === newFilter.operator
    );
  }, []);

  const isFilterActive = useCallback(
    (newFilter: GridFilterItem) =>
      filterModel
        ? filterModel.items.some(existingFilter => isSameFilter(existingFilter, newFilter))
        : false,
    [filterModel, isSameFilter],
  );

  const toggleFilter = useCallback(
    (newFilter: GridFilterItem) => {
      if (!setFilterModel) return;
      setFilterModel(prevFilterModel => {
        const existingFilters = prevFilterModel.items;
        const filterIndex = existingFilters.findIndex(filter => isSameFilter(filter, newFilter));

        if (filterIndex !== -1) {
          // Remove the filter if it exists
          const newFilters = existingFilters.filter((_, index) => index !== filterIndex);
          return { ...prevFilterModel, items: newFilters };
        } else {
          // Add the filter if it does not exist
          return {
            ...prevFilterModel,
            items: [...existingFilters, newFilter],
          };
        }
      });
    },
    [isSameFilter, setFilterModel],
  );

  return {
    isFilterActive,
    toggleFilter,
  };
};

export default useFilters;
